import { useState } from 'react';
import { OSNButtons } from '@hungryroot/app-mhr';
import { CaretDown, CaretUp } from '@hungryroot/icons';
import { PeriodicityTypes } from '@hungryroot/periodicities';
import { Heading } from '@hungryroot/ramen';
import styles from './PdpPeriodicity.module.css';
interface Props {
  testid?: string;
  value: PeriodicityTypes | null;
  productId: number;
  onPeriodicityChange: (periodicity: PeriodicityTypes) => void;
}

export default function PdpPeriodicity(props: Props) {
  const { testid, value, productId, onPeriodicityChange } = props;
  const [expanded, setExpanded] = useState(false);
  const [periodicityText, setPeriodicityText] = useState(value);

  const firstTimeRating = value === null;

  return (
    <div data-testid={testid} className={styles.container}>
      {firstTimeRating ? (
        <Heading
          variant="H6"
          className={styles.header}
          testid={`${testid}-first-time-rating`}
        >
          How often should we send this?
        </Heading>
      ) : (
        <button
          className={styles.expandable}
          onClick={() => setExpanded(!expanded)}
          data-testid={`${testid}-pdp-periodicity-expandable`}
        >
          <Heading variant="H6" className={styles.header}>
            We'll send this to you
          </Heading>
          <Heading
            variant="H6"
            className={styles['selected-value']}
            testid={`${testid}-pdp-periodicity-selected-${periodicityText}`}
          >
            {periodicityText
              ? PeriodicityTypes[periodicityText].toLowerCase()
              : ''}
          </Heading>
          {expanded ? <CaretUp /> : <CaretDown />}
        </button>
      )}
      {(expanded || firstTimeRating) && (
        <div className={styles['buttons-container']}>
          <OSNButtons
            testid={`${testid}-pdp-periodicity`}
            handleClick={(newValue: PeriodicityTypes) => {
              setPeriodicityText(newValue);
              onPeriodicityChange(newValue);
            }}
            selected={value}
            productId={productId}
          />
        </div>
      )}
    </div>
  );
}
